@if (dataLoaded) {
<div class="row mt-2 mb-2">
    @if(showDataBar && serviceUsage && !isUnlimitedData() && !isTelus){
        <div class="col-lg-6">
            <div class="d-flex justify-content-between">
                <div class="d-flex flex-column w-75">
                    <span class="gb-body2 heavy">{{dataRemainingDescription}}</span>
                </div>
            </div>

            <div class="status-cit2 mt-3">
                <div class="status-bar-cit2" role="progressbar" [style.width.%]="serviceUsage.percentRemaining"
                    [attr.aria-valuenow]="serviceUsage.percentRemaining" aria-valuemin="0" aria-valuemax="100"></div>
            </div>

            <div class="d-flex justify-content-between mb-3">
                <span class="gb-body2">0{{serviceUsage.uom}}</span>
                <span class="gb-body2 align-items-right">{{serviceUsage.totalQuantity}} {{serviceUsage.uom}}</span>
            </div>

        </div>
    }
    @if(plan.serviceProvider){
        <div class="col-12 mb-2" >{{getGenericCopy$('myplans.provider', {'PROVIDER' : plan.serviceProvider}) | async}}</div>
    }
    @if(!isUnlimitedData() && plan.templateType ==='PREPAID'){
        <div class="gb-body2 mb-1 col-lg-6">
            <a class="no-href gb-body2 heavy" (click)="goToDataPdp();" [trackLink]="addDataLabel" trackType="o"
                [prop15]="addDataLabel" [prop10]="trackingString('link', [plan.planName, addDataLabel])"
                [evar33]="trackingString('link', [plan.planName, addDataLabel])" tabindex="0">
                {{getGenericCopy$('myplans.expired.plans.modal.data.button') | async}}
            </a>
        </div>
    }
</div>
}

@else {
<ng-template #loadingComponent>
    <ox-loading></ox-loading>
</ng-template>
}